var map = {
	"./backupDemo/horizontal-logo.svg": 28488,
	"./brasilstartups/horizontal-logo.svg": 25075,
	"./caboverde/horizontal-logo.svg": 1493,
	"./canaleducacao/horizontal-logo.svg": 93771,
	"./demo/horizontal-logo.svg": 92061,
	"./egepi/horizontal-logo.svg": 23478,
	"./encceja/horizontal-logo.svg": 84276,
	"./fic/horizontal-logo.svg": 33484,
	"./iesb/horizontal-logo.svg": 40457,
	"./inkluziva/horizontal-logo.svg": 79824,
	"./maiseducacao/horizontal-logo.svg": 5334,
	"./oab/horizontal-logo.svg": 46520,
	"./oros/horizontal-logo.svg": 77515,
	"./pit/horizontal-logo.svg": 65884,
	"./powerforgirls/horizontal-logo.svg": 23089,
	"./quartosecretariado/horizontal-logo.svg": 34176,
	"./retina/horizontal-logo.svg": 1389,
	"./seducpi/horizontal-logo.svg": 90620,
	"./siape/horizontal-logo.svg": 13419,
	"./tjpara/horizontal-logo.svg": 65863,
	"./unisescoop/horizontal-logo.svg": 10217,
	"./vegalabs/horizontal-logo.svg": 77409
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27631;